"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSpothero(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.3 256.8l-9.6-3.2c-6.4-3.2-19.1-6.4-19.1-12.8 0-9.6 9.6-16 19.1-16 9.6 0 19.1 6.4 25.5 12.8l16-31.9c-12.8-9.6-31.9-12.8-47.9-12.8-31.9 0-54.2 19.1-54.2 51 0 25.5 16 35.1 41.5 44.7 9.6 3.2 25.5 6.4 25.5 19.1 0 9.6-12.8 16-22.3 16-12.8-3.2-22.3-9.6-31.9-19.1l-16 31.9c16 9.6 35.1 19.1 54.2 19.1 16 0 31.9-3.2 44.7-16 12.8-9.6 16-25.5 16-41.5-3.3-19-19.2-34.9-41.5-41.3zm143.5 44.7h25.5c28.7 0 54.2-16 54.2-54.2 0-35.1-28.7-51-57.4-51h-60.6v156.3h38.3v-51.1zm0-70.2h12.8c16 0 28.7 0 28.7 19.1s-9.6 19.1-25.5 19.1h-16v-38.2zm220.1 124.4c51 0 86.1-35.1 86.1-86.1 0-44.7-41.5-76.6-86.1-76.6s-86.1 31.9-86.1 79.8c0 47.8 35.1 82.9 86.1 82.9zm0-124.4c25.5 0 44.7 19.1 44.7 41.5 0 25.5-19.1 47.9-44.7 47.9s-44.7-19.1-44.7-47.9c.1-22.4 19.2-41.5 44.7-41.5zm172.3 121.2h38.3V231.3h35.1l-3.2-35.1H736.9l-3.2 35.1H772v121.2h3.2zm-31.9 185c0-102.1-86.1-108.5-108.5-108.5H523.2v370h60.6V655.6h28.7l60.6 146.7c22.3 0 44.7 3.2 67 3.2l-16-35.1L669.9 646c35.1-12.8 73.4-41.5 73.4-108.5zm-108.5 60.6h-51v-118h47.9c22.3 0 51 9.6 51 57.4 0 60.6-47.9 60.6-47.9 60.6zm-271.1 44.7c28.7 0 57.4-3.2 86.1-3.2v-57.4h-86.1V480.1h108.5v-54.2H299.9v376.4c54.2-3.2 111.7-3.2 172.3-3.2v-57.4s-57.4 0-108.5 3.2V642.8zm-185.1-57.4S102 591.8 66.9 595V429.1H0V831c19.1-3.2 41.5-6.4 63.8-9.6v-169l111.7-9.6v165.9c22.3-3.2 41.5-3.2 63.8-3.2V425.9h-63.8l3.1 159.5zm721-159.5c-108.5 0-124.4 76.6-124.4 191.4s9.6 204.2 127.6 210.5c102.1 6.4 121.2-54.2 121.2-210.5-3.2-114.9-19.1-191.4-124.4-191.4zM957 617.3c0 114.8-3.2 149.9-57.4 146.7-57.4-3.2-60.6-44.7-60.6-146.7 0-70.2-3.2-130.8 60.6-130.8 60.6 0 57.4 60.6 57.4 130.8z"
  }));
}

var ForwardRef = React.forwardRef(SvgSpothero);
var _default = ForwardRef;
exports.default = _default;